const formControlLabelFormParamUser = {
  admin: 'Administrator',
  analyst: 'Analyst',
  contractor: 'Third party company'
};

export default formControlLabelFormParamUser;
